import { render, staticRenderFns } from "./ResumenSobrevivencia.vue?vue&type=template&id=d33550de"
import script from "./ResumenSobrevivencia.vue?vue&type=script&lang=ts"
export * from "./ResumenSobrevivencia.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports